module.exports = __webpack_public_path__ + "static/media/visaIcon.a7dc8a9a.svg";